/** Returns a Tailwind text-colour class based on a 1–10 score value. */
export const scoreLabel = (score: number): { text: string } => {
  if (score >= 8) return { text: 'text-green-700' };
  if (score >= 5) return { text: 'text-yellow-600' };
  return { text: 'text-red-600' };
};

/**
 * Strip a repeated category-name prefix from a rubric name.
 * e.g. "Innovation Excellence Award Rubric" → "Rubric"
 */
export const stripCategoryPrefix = (
  rubricName: string,
  categoryName: string
): string => {
  if (!rubricName.startsWith(categoryName)) return rubricName;

  const stripped = rubricName
    .slice(categoryName.length)
    .replace(/^[\s\-–—]+/, '')
    .trim();

  return stripped || rubricName;
};
